module.exports = __webpack_public_path__ + "images/t4t-bureau.svg";